import * as React from 'react';
export const affirmSvg = React.forwardRef(function affirmSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.611 11.658a6.39 6.39 0 0 1-1.051-3.52 6.44 6.44 0 0 1 6.433-6.432 6.44 6.44 0 0 1 6.433 6.433 6.399 6.399 0 0 1-1.052 3.519h1.801a7.952 7.952 0 0 0 .818-3.52c0-4.41-3.589-7.998-8-7.998-4.41 0-7.998 3.588-7.998 7.999 0 1.262.294 2.456.817 3.519h1.8Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.1 4.338c-1.17 0-2.519.552-3.251 1.136l.668 1.406c.587-.537 1.536-.995 2.391-.995.814 0 1.263.272 1.263.82 0 .369-.299.576-.86.628-2.111.194-3.751.853-3.751 2.473 0 1.285.926 2.06 2.45 2.06 1.02 0 1.82-.566 2.252-1.314v1.105h1.9v-4.63c.001-1.912-1.329-2.689-3.061-2.689Zm-.554 6.044c-.616 0-.954-.264-.954-.696 0-.903 1.103-1.12 2.54-1.12 0 .944-.633 1.816-1.586 1.816Z',
    }),
  );
});
affirmSvg.defaultProps = {
  width: '16',
  height: '12',
  viewBox: '0 0 16 12',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var affirm = {
  category: 'paymentmethod',
  colorable: true,
  name: 'affirm',
  svg: affirmSvg,
};
